(() => {
  'use strict';

  const MINIMUM = 4;
  const ROOT = window.Shopify?.routes?.root || '/';

  let refreshTimer;
  let requestId = 0;

  async function updateProgress() {
    const widget = document.getElementById(
      'sweet-sisters-cookie-progress'
    );

    if (!widget) return;

    const currentRequest = ++requestId;

    try {
      const response = await fetch(`${ROOT}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Cart unavailable');

      const cart = await response.json();

      if (currentRequest !== requestId) return;

      const cookieVariants = new Set(
        [...document.querySelectorAll(
          '[data-sweet-sisters-cookie-variant]'
        )].map(el => String(el.dataset.sweetSistersCookieVariant))
      );

      const count = cart.items.reduce((sum, item) => {
        return sum + (
          cookieVariants.has(String(item.variant_id))
            ? item.quantity
            : 0
        );
      }, 0);

      const remaining = Math.max(0, MINIMUM - count);
      const percentage = Math.min(100, count / MINIMUM * 100);

      const fill = widget.querySelector(
        '#sweet-sisters-progress-fill'
      );
      const counter = widget.querySelector(
        '#sweet-sisters-progress-count'
      );
      const message = widget.querySelector(
        '#sweet-sisters-progress-message'
      );
      const track = widget.querySelector(
        '.sweet-sisters-progress-track'
      );

      if (fill) fill.style.width = `${percentage}%`;

      if (counter) {
        counter.textContent = `${count} of ${MINIMUM} cookies`;
      }

      if (message) {
        message.textContent = remaining === 0
          ? 'Your cookie box is ready! 🍪'
          : `Add ${remaining} more ${
              remaining === 1 ? 'cookie' : 'cookies'
            } to complete your box!`;
      }

      if (track) {
        track.setAttribute(
          'aria-valuenow',
          String(Math.min(count, MINIMUM))
        );
      }
    } catch (error) {
      console.error('Sweet Sisters progress:', error);
    }
  }

  function scheduleUpdate() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(updateProgress, 350);
  }

  function initialize() {
    updateProgress();

    // Shopify Craft cart quantity changes.
    document.addEventListener('change', event => {
      if (event.target.closest('cart-items')) {
        setTimeout(scheduleUpdate, 500);
      }
    });

    // Detect cart HTML updates.
    const cartItems = document.querySelector('cart-items');

    if (cartItems) {
      const observer = new MutationObserver(scheduleUpdate);

      observer.observe(cartItems, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Refresh after returning to the cart tab.
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scheduleUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();